import { createLogger } from '@telia-ace/edge-log';

import { callEventHandler } from '../clientInterface';
import * as chatState from '../chatState';

const log = createLogger('onsite');

export async function setupVideo({ userUrl, infoText, agent }) {
  log.debug('setupVideo:', userUrl);
  callEventHandler('showVideo', { userUrl, infoText, agent });
  chatState.set('videoConnected', true);
}

export async function chatButtonClicked({ guestId }) {
  log.debug('chatButtonClicked:', guestId);
  callEventHandler('chatButtonClicked', { guestId });
}

export async function endVideoButtonClicked({ guestId }) {
  log.debug('endVideoButtonClicked:', guestId);
  callEventHandler('endVideoButtonClicked', { guestId });
}

export function reloadVideoSession(args) {
  log.debug('reloadVideoSession not applicable for this video provider!', args);
}

export function reloadVideoPublisher(args) {
  log.debug('reloadVideoPublisher not applicable for this video provider!', args);
}

export function stopVideo(args) {
  log.debug('stopVideo:', args);
  callEventHandler('stopVideo', { args });
  chatState.set('videoConnected', false);
}

export function disconnectSession(args) {
  log.debug('disconnectSession not applicable for this video provider!', args);
}

export function suspendVideo(args) {
  log.debug('suspendVideo not applicable for this video provider!', args);
}

export function sendStopVideoToClient(args) {
  log.debug('sendStopVideoToClient not applicable for this video provider!', args);
}

export function muteSpeaker(args) {
  log.debug('muteSpeaker not applicable for this video provider!', args);
}

export function muteMicrophone(args) {
  log.debug('muteMicrophone not applicable for this video provider!', args);
}

export function muteVideo(args) {
  log.debug('muteVideo not applicable for this video provider!', args);
}

export function cycleVideo(args) {
  log.debug('cycleVideo not applicable for this video provider!', args);
}

export function disconnectVideoWindowController(args) {
  log.debug('disconnectVideoWindowController not applicable for this video provider!', args);
}

export function takeVideoWindow(args) {
  log.debug('takeVideoWindow not applicable for this video provider!', args);
}
